import styled from "styled-components";

const SubsectionTitle = styled.p`
    font-size: 32px;
    font-family: BlenderProBold, serif;
    background: -webkit-linear-gradient(left, #1F1F1F, ${({color}) => color});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
`;

export default SubsectionTitle;
